import {Component} from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-articolo-giacenza-modal',
  templateUrl: './articolo-giacenza-modal.component.html',
  styleUrls: ['./articolo-giacenza-modal.component.scss'],
  standalone: false
})
export class ArticoloGiacenzaModalComponent {
  codArt = '';

  constructor(
    private modalCtrl: ModalController) { }


  cancel = () => this.modalCtrl.dismiss(false, 'cancel');
}
